import { softEquals } from "@evergis/sgis/es/utils/math";

import { i18n } from "../i18n";

// NOTE чтобы рисовался при инициализации за пределами карты
export const DEFAULT_LABEL_POSITION: [number, number] = [Infinity, Infinity];

export const isPositionEqual = (a: [number, number], b: [number, number]): boolean => {
  return softEquals(a[0], b[0]) && softEquals(a[1], b[1]);
};

function numberWithSpaces(x: number, fractionDigits = 2, delim: "," | "." = ","): string {
  const [num, frac] = x.toFixed(fractionDigits).split(".");
  const numWithSpaces = num.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

  return [numWithSpaces, frac].join(delim);
}

export function formatArea(num: number): string {
  let result = num;
  let measure = i18n.t("sqMeter", { ns: "common" });

  if (num >= 10000000) {
    result = num / 1000000;
    measure = i18n.t("sqKilometer", { ns: "common" });
  } else if (num >= 10000) {
    result = num / 10000;
    measure = i18n.t("hectare", { ns: "common" });
  }

  return `${numberWithSpaces(result)} ${measure}`;
}

export function formatLength(num: number): string {
  let result = num;
  let measure = i18n.t("meter", { ns: "common" });

  if (num > 10000) {
    result = num / 1000;
    measure = i18n.t("kilometer", { ns: "common" });
  }

  return `${numberWithSpaces(result)} ${measure}`;
}

export function formatPolygonMeasure(area: number, perimiter: number): string {
  return `S : ${formatArea(area)}  P : ${formatLength(perimiter)}`;
}

export function polylineLikePolygon(rings: [number, number][][], resolution: number): boolean {
  if (rings[0].length <= 3) {
    return false;
  }

  const coords = rings[0];
  const firstPoint = coords[0];
  const lastPoint = coords[coords.length - 1];
  const distance = resolution * 2;

  return softEquals(firstPoint[0], lastPoint[0], distance) && softEquals(firstPoint[1], lastPoint[1], distance);
}
